export function getWorkXPFromNumber(years: number | string) {
  const s = String(years);
  const len = s.length;
  const lastDigit = s[len - 1];
  return `от ${s} ${lastDigit === '1' ? 'года' : 'лет'}`;
}
